import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import HomePage from './pages/HomePage';
import BookDetailPage from './pages/BookDetailPage';
import ReaderPage from './pages/ReaderPage';
import AdminPage from './pages/AdminPage';
import { Toaster } from './components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session ID for analytics
const getSessionId = () => {
  let sessionId = localStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(7)}`;
    localStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};

export { getSessionId };

function App() {
  const [stats, setStats] = useState({ platform_visits: 0, total_reads: 0 });

  useEffect(() => {
    // Track platform visit
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track/visit`, {
          type: 'visit',
          session_id: getSessionId()
        });
      } catch (error) {
        console.error('Failed to track visit:', error);
      }
    };

    trackVisit();

    // Fetch platform stats
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/stats/platform`);
        setStats(response.data);
      } catch (error) {
        console.error('Failed to fetch stats:', error);
      }
    };

    fetchStats();

    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage stats={stats} />} />
          <Route path="/book/:id" element={<BookDetailPage />} />
          <Route path="/read/:id" element={<ReaderPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;